export default "__VITE_ASSET__5173e3b8__"